import { useQuery } from "@tanstack/react-query";
import { categoryApi } from "../services/category.api";
import { TCategoryFilter } from "../../../interfaces/categoryInterface";
import { IApiPagination } from "../../../interfaces/IPagination";

export type UseCategoriesFilterQueryParams = {
  filter: TCategoryFilter;
  pagination: IApiPagination;
};

export const useCategoriesFilterQuery = (
  params: UseCategoriesFilterQueryParams,
) => {
  return useQuery({
    queryKey: ["categories-filter", params],
    queryFn: async () => {
      const res = await categoryApi.getCategories(
        params.filter,
        params.pagination,
      );
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};

export const useCategoryByIdQuery = (categoryId?: string) => {
  return useQuery({
    queryKey: ["category-by-id", categoryId],
    queryFn: () => categoryApi.getCategoryById(categoryId as string),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!categoryId,
  });
};
